import { OpenOrderReport } from '../../types/entities';

export interface OpenOrderState {
  loading: boolean;
  loaded: boolean;
  error?: string;
  orders: OpenOrderReport[];
}

export const initialOpenOrderState: OpenOrderState = {
  loading: false,
  loaded: false,
  error: undefined,
  orders: []
};
